import { Skeleton } from '@/components/ui/skeleton'

export const PromotionDetailsSkeleton = () => (
    <div className="w-full">
        <div className="mb-6 flex items-center gap-2">
            <Skeleton className="h-10 w-10" />
            <Skeleton className="h-8 w-64" />
        </div>
        <div className="space-y-4">
            <Skeleton className="h-32 w-full" />
            <Skeleton className="h-32 w-full" />
            <Skeleton className="h-32 w-full" />
        </div>
    </div>
)

